import { useContext, useEffect } from 'react';
import { useLazyQuery } from '@apollo/client';
import * as R from 'ramda';

import { GET_ASSET_REQUESTS } from '@atom/graph/assetRequest';
import {
  AssetRequestsConnection,
  AssetRequestsConnectionInput,
  AssetRequestStatus,
} from '@atom/types/assetRequest';
import {
  Client,
  isCurrentClient,
} from '@atom/utilities/featureToggleUtilities';

import CreateRequest from './createRequest/CreateRequest';
import RequestsContext from './RequestsContext';

import classes from './requests.module.css';

const RequestsHeader = () => {
  const { totalCount, asset } = useContext(RequestsContext);

  const [getAssetRequests, { data, loading: assetRequestsLoading }] =
    useLazyQuery<
      { assetRequests: AssetRequestsConnection },
      { input: AssetRequestsConnectionInput }
    >(GET_ASSET_REQUESTS, {
      fetchPolicy: 'network-only',
    });

  useEffect(() => {
    if (isCurrentClient([Client.ARDOT])) {
      getAssetRequests({
        variables: {
          input: {
            page: 1,
            limit: 1,
            assetId: asset?.id,
            statuses: [
              AssetRequestStatus.PENDING_APPROVAL,
              AssetRequestStatus.PENDING_REVIEW,
            ],
          },
        },
      });
    }
  }, [totalCount]);

  const pendingCount = R.pathOr(0, ['assetRequests', 'totalCount'], data);
  const showCreate = !assetRequestsLoading && pendingCount === 0;

  return (
    <>
      <div className={classes.requestsHeader}>
        <div>{`${totalCount} Requests`}</div>
        {showCreate && <CreateRequest />}
      </div>
    </>
  );
};

export default RequestsHeader;
